import { Button } from "@shared/ui/button";
import { useTranslation } from "react-i18next";

interface ConsumerDetailsReviewProps {
  data?: any;
  onEdit?: () => void;
}

export function ConsumerDetailsReview({
  data,
  onEdit,
}: ConsumerDetailsReviewProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">{t("Consumer Details")}</h2>
        <Button variant="outline" size="sm" onClick={onEdit}>
          Edit
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* First Name */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("First Name")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.first_name || t("Not specified")}
          </p>
        </div>

        {/* Last Name */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Last Name")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.last_name || t("Not specified")}
          </p>
        </div>

        {/* Email */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Email")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.email || t("Not specified")}
          </p>
        </div>

        {/* Phone Number */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Phone Number")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.phone_number || t("Not specified")}
          </p>
        </div>

        {/* Account Category */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Category")}</p>
          <p className="text-base text-gray-900 font-medium capitalize">
            {data?.account_category_display || t("Not specified")}
          </p>
        </div>

        {/* Account Sub-Category */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Subcategory")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.account_sub_category_display
              ?.split("_")
              .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ") || t("Not specified")}
          </p>
        </div>

        {/* SSN/Tax ID */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("SSN/Tax ID")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.ssn || t("Not specified")}
          </p>
        </div>

        {/* Date of Birth */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("Date of Birth")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.date_of_birth || t("Not specified")}
          </p>
        </div>

        {/* VIP Designation */}
        <div>
          <p className="text-sm text-gray-600 mb-1">{t("VIP Designation")}</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.vip_designation ? t("Yes") : t("No")}
          </p>
        </div>
      </div>

      {/* Co-Applicant Section */}
      {data?.add_co_applicant && data?.co_applicant && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            {t("Co-Applicant Details")}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
  <p className="text-sm text-gray-600 mb-1">{t("Secondary Relationship")}</p>
  <p className="text-base text-gray-900 font-medium">
    {data.co_applicant?.relationship_display || t("Not specified")}
  </p>
</div>
            <div>
              <p className="text-sm text-gray-600 mb-1">{t("First Name")}</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.first_name || t("Not specified")}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">{t("Last Name")}</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.last_name || t("Not specified")}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">{t("Email")}</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.email || t("Not specified")}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">{t("Phone Number")}</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.phone_number || t("Not specified")}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}